var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.956,
    height: 14.328,
    viewBox: "0 0 11.956 14.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1645.328 694.4l-.286-2.469a5.08 5.08 0 0 0-3.437-4.756v-.555a1.619 1.619 0 0 0-1.618-1.581h-.039a1.619 1.619 0 0 0-1.581 1.583v.553a5.074 5.074 0 0 0-3.437 4.744l-.287 2.481a1.758 1.758 0 0 0-.636 1.355v.1c0 1.341 1.331 1.341 1.768 1.341h1.567a2.573 2.573 0 0 0 2.534 2.173 2.474 2.474 0 0 0 .308-.019 2.564 2.564 0 0 0 2.238-2.155h1.772c.438 0 1.769 0 1.769-1.341v-.1a1.735 1.735 0 0 0-.635-1.354zm-4.522 2.993a1.08 1.08 0 0 1-1.846 0zm-.66-10.771v1.7l.578.121a3.645 3.645 0 0 1 2.864 3.541l.381 3.324.363.174a.311.311 0 0 1 .176.247 2.251 2.251 0 0 1-.312.011h-8.425a2.34 2.34 0 0 1-.309-.011.312.312 0 0 1 .179-.253l.361-.174.377-3.261v-.071a3.638 3.638 0 0 1 2.863-3.528l.578-.121v-1.7a.163.163 0 1 1 .326 0z",
    transform: "translate(-1634.007 -685.042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.12c6c71f.svg";
export { ForwardRef as ReactComponent };